import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface SKU {
  SkuId: string;
  ProductId: string;
  ProductSkuNum: number;
  Name: string;
  Description: string;
  CostMacroCategoryCd: string;
  CostMetricCd: string;
  CostMetricCost: number;
  CurrencyCd: string;
  CostIntervalCd: string;
  CostIntervalMin: number;
  CostIntervalMax: number;
  IsAutoProvisioned: boolean;
  IsReturnable: boolean;
  StatusCd: string;
  CreatedUser: string;
  UpdatedUser: string;
  CreatedDtm: string;
  UpdatedDtm: string;
  OrderQuantity: number;
  OrderInterval: number;
}

interface Order {
  OrderParentId: number;
  Description: string;
  OpportunityId: string;
  EngagementId: string;
  ServiceCodes: null;
  StatusCd: string;
  CreatedDtm: string;
  UpdatedDtm: string;
  CreatedUser: string;
  UpdatedUser: string;
  Requestor: null;
  Details: [
    {
      ProductName: string;
      AssetAdvice: string;
      SkuDetails: SKU[];
    }
  ];
}

interface ProductListState {
  isLoading: boolean;
  data: Order[] | null;
  error: string | null;
}

export interface ResponseError {
  message: string;
}

export interface deploymentApproverObject {
  orderSkuId: number; // Replace with actual OrderSkuId
  statusCd: string;
  completionDate?: Date | null | undefined;
}

const initialState: ProductListState = {
  isLoading: true,
  data: null,
  error: null,
};

export const deployementApproverProvStatus = createAsyncThunk<
  any,
  deploymentApproverObject,
  { rejectValue: ResponseError }
>(
  "deployementApproverProvStatusSlice/deployementApproverProvStatus",
  async (requestObject, thunkApi) => {
     try {
      const response = await httpClient.post("/order/sku/status", requestObject);
      const successStatusCodes = [200, 201, 202];
      if (
        !successStatusCodes.includes(response.status) 
      ) {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to update status.",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.error("🚀 ~ error:", error);
      // return thunkApi.rejectWithValue({
      //   message: "Failed to update status.",
      // });
    }
  }
);

const deployementApproverProvStatusSlice = createSlice({
  name: "deployementApproverProvStatusSlice",
  initialState,
  reducers: {
    resetOrderPipelineListState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deployementApproverProvStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        deployementApproverProvStatus.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        deployementApproverProvStatus.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message || "Failed to update status";
        }
      );
  },
});

export const { resetOrderPipelineListState } =
  deployementApproverProvStatusSlice.actions;

export default deployementApproverProvStatusSlice.reducer;
